import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import { commonSelectSx } from 'styles/muiStyles';

export interface BaseSubProvider {
  id: number | string;
  name: string;
  code?: string;
  displayName?: string;
}

interface SubProviderSelectProps {
  subProviders: BaseSubProvider[];
  selectedValue: string;
  onChange: (value: string) => void;
  className?: string;
  label?: string;
  disabled?: boolean;
  sx?: any;
}

const SubProviderSelect: React.FC<SubProviderSelectProps> = ({
  subProviders,
  selectedValue,
  onChange,
  className = '',
  label = 'Sub Providers',
  disabled = false,
  sx = {},
}) => {
  const handleChange = (e: SelectChangeEvent<string>) => {
    onChange(e.target.value);
  };

  return (
    <FormControl fullWidth size="small" className={className}>
      <InputLabel
        sx={{
          color: '#8698a6',
          '&.Mui-focused': {
            color: '#8698a6',
          },
        }}
      >
        {label}
      </InputLabel>
      <Select
        value={selectedValue}
        label={label}
        onChange={handleChange}
        disabled={disabled}
        sx={{
          ...commonSelectSx,
          ...sx,
        }}
        MenuProps={{
          PaperProps: {
            style: { maxHeight: 300 },
          },
        }}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {subProviders.map((sp) => {
          const val = sp.name;
          return (
            <MenuItem key={sp.id} value={val}>
              {sp.displayName || sp.name}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default SubProviderSelect;
